import React, { useEffect, useRef, useState } from 'react'
import "./AddRole.css";
//import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { getRoles } from '../../../services/employeeCreationService';
import { deleteRole } from '../../../services/roleServiceMapService';

const AddRole = () => {
    const [confirmDeleteId, setConfirmDeleteId] = useState(null);
    const [roles, setRoles] = useState([]);
    const navigate = useNavigate();
    const effectRan = useRef(false);

    const fetchRoles = async () => {
        //const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/role`);
        const data = await getRoles();
        setRoles(data);
    }
    useEffect(() => {
        if (!effectRan.current) {
            fetchRoles();
        }
        return () => {
            effectRan.current = true;
        }
    }, []);
    const handleDelete = async (id) => {
        try {
            await deleteRole(id);
            setRoles((prevRoles) => prevRoles.filter((role) => role.roleId !== id));
            //alert("Role deleted successfully!");
        } catch (error) {
            console.error("Failed to delete role:", error);
            alert("Failed to delete role. Please try again.");
        }
    };

    const CreateRole = () => {
        navigate("/createRole");
    }

    return (
        <div className="roles-list-container">
            <div className='div-list-roles'>
                <div><button onClick={CreateRole} className='navi-create-role'>Add Role</button></div>
                <div className="head-dics-roles-list">
                    <h2>Roles List</h2>
                    {/* <h2>قائمة الأدوار</h2> */}
                </div>

                <table className="roles-table">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Roles</th>
                            {/* <th className="rtl-column">الأدوار</th> */}
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {roles.map((role, index) => (
                            <tr key={role.roleId}>
                                <td>{index + 1}</td>
                                <td>{role.roleName}</td>
                                {/* <td className="rtl-column">{role.roleSl}</td> */}
                                <td >
                                    <div className='btn-roles'>
                                        <Link to={`/roles/edit/${role.roleId}`}>
                                            <button className="update-role">Edit</button>
                                        </Link>
                                        <button className="delete-role" onClick={() => setConfirmDeleteId(role.roleId)}>Delete</button>
                                    </div>

                                </td>

                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {confirmDeleteId && (
                <div className="confirm-overlay">
                    <div className="confirm-box">
                        <p>Do you really want to delete it / هل تريد حقًا حذفه </p>
                        <div className="confirm-actions">
                            <button
                                type="button"
                                onClick={async () => {
                                    await handleDelete(confirmDeleteId);
                                    setConfirmDeleteId(null); // Close the dialog
                                    // setSuccessMessage("Draft application deleted successfully");
                                }}
                            >
                                Yes
                            </button>

                            <button type="button" onClick={() => setConfirmDeleteId(null)}>
                                No
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
export default AddRole;